import script from "./TournamentSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TournamentSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./TournamentSidebar.vue?vue&type=style&index=0&id=4d23b618&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d23b618"]])

export default __exports__